module.exports = __webpack_public_path__ + "rosacea_8_after_tn.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures_tn/dermatologie/rosacea_8_after_tn.jpg
// module id = 1459
// module chunks = 0